import {Variants} from 'framer-motion';

export const headingVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      delay: 0.75,
      duration: 0.33,
      ease: 'easeInOut',
    },
  },
};

export const subheadingVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      delay: 1,
      duration: 0.33,
      ease: 'easeInOut',
    },
  },
};
